import { Card } from '../ui/card';

const TestListingLoader = ({ isLocked = false }) => {
  return (
    <div className={`w-full ${isLocked ? 'px-4' : 'px-0'} text-center`}>
      {/* Test Cards */}
      {isLocked && <div className="h-8 bg-gray-400 rounded animate-pulse w-64 mb-2"></div>}
      <div className="space-y-4 pb-3">
        {[...Array(5)].map((_, index) => (
          <Card key={index} className="bg-[var(--q3-surface-default)] rounded-lg shadow-none py-0 overflow-hidden">
            <div className="flex flex-col w-full">
              {/* Main Card Content */}
              <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 px-2 lg:px-5 py-2 lg:py-4">
                <div className="flex items-center w-full lg:w-fit gap-5">
                  {/* Test Number/Icon */}
                  <div className="hidden lg:flex items-center justify-center w-6 h-6 bg-gray-400 rounded-full animate-pulse"></div>

                  <div className="flex flex-col w-full lg:w-fit">
                    <div className="flex items-start justify-start gap-2 w-full lg:w-fit text-left">
                      {/* Test Title */}
                      <div className="h-6 bg-gray-400 rounded animate-pulse w-64 mb-2"></div>
                      {/* Badge */}
                      <div className="h-5 bg-gray-400 rounded-full w-16 animate-pulse"></div>
                    </div>

                    {/* Description */}
                    <div className="flex items-center flex-wrap gap-2 mt-1">
                      <div className="h-4 bg-gray-400 rounded animate-pulse w-48"></div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex w-full lg:w-fit flex-row gap-2">
                  <div className="flex-1 h-10 bg-gray-400 rounded-full animate-pulse"></div>
                  <div className="flex-1 h-10 bg-gray-400 rounded-full animate-pulse"></div>
                </div>
              </div>

              {/* Bottom Stats Section */}
              <div className="px-2 lg:pl-18 lg:pr-4 flex justify-between items-center py-2 bg-[var(--q3-surface-dimmer)] flex-wrap">
                <div className="flex items-center gap-3 flex-wrap">
                  <div className="flex items-center gap-1">
                    <div className="w-5 h-5 bg-gray-400 rounded animate-pulse"></div>
                    <div className="h-4 bg-gray-400 rounded animate-pulse w-12"></div>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-5 h-5 bg-gray-400 rounded animate-pulse"></div>
                    <div className="h-4 bg-gray-400 rounded animate-pulse w-16"></div>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-5 h-5 bg-gray-400 rounded animate-pulse"></div>
                    <div className="h-4 bg-gray-400 rounded animate-pulse w-14"></div>
                  </div>
                </div>
                <div className="h-6 bg-gray-400 rounded-full w-24 animate-pulse"></div>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Pagination */}
      <div className="mt-6">
        <div className="flex items-center justify-center gap-2">
          <div className="h-10 bg-gray-400 rounded w-20 animate-pulse"></div>
          {[...Array(5)].map((_, index) => (
            <div key={index} className="h-10 w-10 bg-gray-400 rounded animate-pulse"></div>
          ))}
          <div className="h-10 bg-gray-400 rounded w-16 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
export default TestListingLoader;
